<template>
  <div>

    <v-data-table
      :headers="headers"
      :items="versionModules"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-spacer/>
          <v-dialog v-model="newDialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
            </template>
            <v-card>
              <v-card-actions>
                <v-text-field v-model="searchString" @keyup.enter="search" placeholder="Search modules">
                </v-text-field>
                <v-spacer/>
                <v-btn
                  min-width="0"
                  class="pa-0 px-2 text--brand-primary"
                  @click="search"
                >Search
                </v-btn>
                <v-spacer/>
                <v-btn color="blue darken-1" text @click="newDialog = !newDialog">Cancel</v-btn>
              </v-card-actions>
              <v-data-table
                v-if="!loading"
                :headers="searchedModulesTabHeaders"
                :items="searchedModules">
                <template v-slot:item.action="{ item }">
                  <v-icon
                    class="mr-2 add"
                    @click="addModuleToVersion(item)"/>
                </template>
              </v-data-table>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon
          class="mr-2 delete"
          @click="deleteModuleFromVersion(item)"/>
      </template>

    </v-data-table>

  </div>
</template>

<script>
import store from '../../store';

export default {
  name: 'ModulesForVersionList',
  props: ['version', 'title'],

  data() {
    return {
      headers: [
        { text: 'Modules', value: 'name', sortable: false },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      searchedModulesTabHeaders: [
        { text: 'Modules', value: 'name', sortable: false },
        { text: 'App name', value: 'app.name', sortable: false },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      objects: [],
      searchedObjects: [],
      newDialog: false,
      searchString: '',

    };
  },

  computed: {
    id() {
      return this.$route.params.id;
    },
    versionModules() {
      return this.objects;
    },
    searchedModules() {
      return this.searchedObjects;
    },
    loading() {
      return store.state.loadingCounter;
    },
  },

  methods: {
    setModulesForVersion() {
      this.$http.get(`api/modules?versions.id=${this.id}`).then((data) => {
        this.objects = data.data;
      });
    },

    deleteModuleFromVersion(module) {
      const modules = [];
      this.versionModules.forEach((el) => {
        if (module.id !== el.id) {
          modules.push(`/api/modules/${el.id}`);
        }
      });
      const updatedVersion = { modules };
      this.$http.patch(`api/versions/${this.id}`, updatedVersion, {
        headers: {
          'Content-Type': 'application/merge-patch+json',
        },
      }).then(() => {
        this.setModulesForVersion();
      });
    },

    addModuleToVersion(newModule) {
      const modules = [];
      this.versionModules.forEach((el) => {
        modules.push(`/api/modules/${el.id}`);
      });
      modules.push(`/api/modules/${newModule.id}`);
      const updatedVersion = { modules };
      this.$http.patch(`api/versions/${this.id}`, updatedVersion, {
        headers: {
          'Content-Type': 'application/merge-patch+json',
        },
      }).then(() => {
        this.setModulesForVersion();
      });
    },

    async search() {
      await this.$http.get(`api/modules?name=${this.searchString}`).then((data) => {
        this.searchedObjects = data.data;
      });
      this.setAppsNameToModules();
    },

    async setAppsNameToModules() {
      const allAppsNameArray = await this.getAllAppsName();
      // console.log(allAppsNameArray);
      this.searchedObjects.forEach((el) => {
        const elementId = el.app.id;
        const elementObject = el;
        allAppsNameArray.forEach((appsNameArray) => {
          const appId = appsNameArray.id;
          if (appId === elementId) {
            elementObject.app = { name: appsNameArray.name };
          }
        });
      });
    },
    async getAllAppsName() {
      let allAppsArray;
      await this.$http.get('api/apps').then((data) => {
        allAppsArray = data.data;
      }).catch((error) => {
        console.log(error);
      });
      return allAppsArray;
    },
  },

  created() {
    this.setModulesForVersion();
  },
};
</script>

<style scoped>

</style>
